import { ReactElement } from 'react';

import imgUrlXs from 'consumer/errors/logged-in-error-page-xs.jpg';
import imgUrlXs2x from 'consumer/errors/logged-in-error-page-xs@2x.jpg';
import imgUrlXxs from 'consumer/errors/logged-out-error-page-xxs.jpg';
import imgUrlXxs2x from 'consumer/errors/logged-out-error-page-xxs@2x.jpg';

import { Route } from 'config';

function ErrorPage(): ReactElement {
  return (
    <div className="c-errors c-errors-logged-in">
      <div className="row d-flex align-items-center c-errors__container">
        <div className="row">
          <div className="col-12 col-sm-8 col-md-12 col-lg-8">
            <div className="c-errors__heading">
              <h2 className="c-heading c-heading--brand-3">
                Oops!
                <br />
                Something went wrong.
              </h2>
            </div>
            <p className="u-text u-text--lg"><strong>You can try to:</strong></p>
            <ul className="c-errors__links c-errors__links--single-column">
              <li>
                <a href=".">
                  Reload the page
                </a>
              </li>
              <li>
                <a href={Route.UPCOMING_MENUS}>
                  Return to Homepage
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <picture>
        <source
          type="image/jpeg"
          media="(min-width: 415px)"
          srcSet={`${imgUrlXs} 1x, ${imgUrlXs2x} 2x`}
        />
        <source
          type="image/jpeg"
          media="(max-width: 414px)"
          srcSet={`${imgUrlXxs} 1x, ${imgUrlXxs2x} 2x`}
        />
        <img
          src={imgUrlXxs}
          srcSet={`${imgUrlXxs} 1x, ${imgUrlXxs2x} 2x`}
          alt=""
          className="d-block d-sm-none"
        />
      </picture>
    </div>
  );
}

export default ErrorPage;
